import { render, staticRenderFns } from "./NewDashbord.vue?vue&type=template&id=4aaaf09c&scoped=true"
import script from "./NewDashbord.vue?vue&type=script&lang=js"
export * from "./NewDashbord.vue?vue&type=script&lang=js"
import style0 from "./NewDashbord.vue?vue&type=style&index=0&id=4aaaf09c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaaf09c",
  null
  
)

export default component.exports